export default __webpack_public_path__ + "static/media/ulala.5bfa9c52.png";